import { setSmallScreenWarningModal } from '../../store/general/slice';
import { SmallScreenIllustration } from '../../assets/illustrations';
import { useDispatch } from '../../store/store';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function SmallScreenWarning() {
    const dispatch = useDispatch();

    return (
        <Modal
            size='sm'
            actions='confirm'
            childClassName={styles.wrapper}
            confirmButton={{
                text: 'Continue anyway',
                type: 'Primary',
                onClick: () => dispatch(setSmallScreenWarningModal(false)),
            }}
        >
            <SmallScreenIllustration />
            <p className={styles.text}>
                Please use a wider screen device<br /> for a better experience.
            </p>
        </Modal >
    )
}
